<template>
	<div>
		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h" :rules="rules">
			<a-row type="flex" class=" font-bold bb">
				<a-col>
					<p class="blank-l-h">基础信息</p>
				</a-col>
			</a-row>
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p >所属项目</p>
						</a-col>
						<a-col>
							<a-form-model  layout="vertical" :rules="rules" ref="table" :model="table" >
								<a-form-model-item prop='community_id'>
									<a-select class="app-block" placeholder="请选择设备所属项目" v-model="table.community_id" >
										<a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">
											{{value.name}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-form-model>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备类别</p>
						</a-col>
						<a-col>
							<a-form-model  layout="vertical" :rules="rules" ref="table" :model="table">
								<a-form-model-item prop='device_type_id'>
									<a-select class="app-block" placeholder="请选择设备类别" v-model="table.device_type_id" >
										<a-select-option :value="value.id" v-for="value in deviceOptions" :key="value.id">
											{{value.name}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-form-model>
						</a-col>
					</a-row>
				</a-col>

				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备名称</p>
						</a-col>
						<a-col>
							<a-form-model  layout="vertical" :rules="rules" ref="table" :model="table">
								<a-form-model-item  prop="name">
									<a-input placeholder="请输入设备名称" v-model="table.name" ></a-input>
								</a-form-model-item>
							</a-form-model>
							
						</a-col>
					</a-row>
				</a-col>
			</a-row>
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v ">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>空间位置</p>
						</a-col>
						<a-col>
							<a-form-model  layout="vertical" :rules="rules" ref="table" :model="table">
								<a-form-model-item  prop="position">
									<a-input placeholder="请输入设备所在空间位置" v-model="table.position" ></a-input>
								</a-form-model-item>
							</a-form-model>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备编号</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入设备编号" v-model="table.device_sn"></a-input>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备型号</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入设备型号" v-model="table.device_model"></a-input>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v ">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>购置日期</p>
						</a-col>
						<a-col>
							<a-date-picker placeholder="请选择设备购置日期" v-model="table.purchase_date"
								:default-value="moment(table.purchase_date)" @change="onChange" valueFormat="YYYY-MM-DD"
								style="width: 100%" />
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>购置价格</p>
						</a-col>
						<a-col>
							<a-input-number :min="0" :step="0.1" :precision='2' placeholder="请输入设备购置价格"
								v-model="table.purchase_price" style="width: 100%" />
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>启用日期</p>
						</a-col>
						<a-col>
							<a-date-picker placeholder="请选择设备启用日期" v-model="table.enable_date"
								:default-value="moment(table.enable_date)" @change="onChange" format="YYYY-MM-DD"
								style="width: 100%" />
						</a-col>
					</a-row>
				</a-col>
			</a-row>

			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v blank-b-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>年折旧率</p>
						</a-col>
						<a-col>
							<a-input-number :min="0" :step="0.1" :precision='2' placeholder="请输入年折旧率"
								v-model="table.depreciation_rate" style="width: 100%"></a-input-number>
						</a-col>
					</a-row>
				</a-col>

				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>可用年限（年）</p>
						</a-col>
						<a-col>
							<a-input-number :min="0" placeholder="请输入设备可用年限" v-model="table.year_limit"
								style="width: 100%"></a-input-number>
						</a-col>
					</a-row>
				</a-col>

				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>设备品牌</p>
						</a-col>
						<a-col>
							<a-input placeholder="请输入设备品牌" v-model="table.brand"></a-input>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
		</div>

		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h">
			<a-row type="flex" class=" font-bold bb">
				<a-col>
					<p class="blank-l-h">生产商信息</p>
				</a-col>
			</a-row>
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v blank-b-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 6]">
						<a-col>
							<p>生产商</p>
						</a-col>
						<a-col>
							<a-form-model  layout="vertical" :rules="rules" ref="table" :model="table">
								<a-form-model-item prop='make_mill_id'>
									<a-select class="app-block" placeholder="请输入设备生产商" v-model="table.make_mill_id" >
										<a-select-option :value="value.id" v-for="value in VendorsOptions" :key="value.id">
											{{value.name}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-form-model>
						</a-col>

					</a-row>
				</a-col>

				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 6]">
						<a-col>
							<p>联系人</p>
						</a-col>
						<a-col>
							<a-select class="app-block" placeholder="请选择生产商联系人" disabled>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 6]">
						<a-col>
							<p>联系电话</p>
						</a-col>
						<a-col>
							<a-input placeholder="生产商联系电话" disabled></a-input>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
		</div>

		<div class="device-type-info app-region blank-t-v blank-l-h blank-r-h">
			<a-row type="flex" class=" font-bold bb">
				<a-col>
					<p class="blank-l-h">维保商信息</p>
				</a-col>
			</a-row>
			<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal blank-t-v blank-b-v">
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>维保商</p>
						</a-col>
						<a-col>
							<a-select class="app-block" placeholder="请输入设备维保商" v-model="table.repair_mill_id">
								<a-select-option :value="value.id" v-for="value in VendorsOptions" :key="value.id">{{value.name}}</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>联系人</p>
						</a-col>
						<a-col>
							<a-select class="app-block" disabled placeholder="请选择维保负责人">
							</a-select>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="24" :xl="8">
					<a-row :gutter="[8, 8]">
						<a-col>
							<p>联系电话</p>
						</a-col>
						<a-col>
							<a-input placeholder="维保商联系电话" disabled></a-input>
						</a-col>
					</a-row>
				</a-col>
			</a-row>
		</div>

		<footer class="app-footer blank-t-v blank-b-v ">
			<a-row type="flex" justify="end">
				<a-col>
					<a-space>
						<a-button @click="cancel">取消</a-button>
						<a-button type="primary" @click="submit">提交</a-button>
					</a-space>
				</a-col>
			</a-row>
		</footer>
		<div class="bottombox"></div>

	</div>


</template>

<script>
	import CommunityService from '@/io/community.js';
	import Equipment from "@/io/equipment.js";
	import DeviceType from '@/io/device_type.js';
	import Vendors from '@/io/vendors.js';

	import {
		deviceTypes
	} from '@/io/dict.js'
	import moment from 'moment';
	export default {
		name: 'NewEquipmentInfo',
		data() {
			let self = this;
			return {
				// 传来的id
				id: this.$route.params.id,
				deviceTypes,
				table: {
					loading: false,

					community_id: null,
					device_type_id: null,
					name: null,
					brand: null,
					position: null,
					device_model: null,
					purchase_date: undefined,
					purchase_price: null,
					enable_date:undefined,
					depreciation_rate: null,
					year_limit: null,
					make_mill_id: null,
					repair_mill_id: null,

					data: [],

				},
				rules:{
					community_id:[{
						required: true,
						message: "请选择设备所属项目",
					}],
					device_type_id:[{
						required: true,
						message: "请选择设备类别",
					}],
					name:[{
						required: true,
						message: "请输入设备名称",
					}],
					position:[{
						required: true,
						message: "请输入设备所在空间位置",
					}],
					make_mill_id:[{
						required: true,
						message: "请输入设备生产商 ",
					}],
				},
				
				communityOptions: [],
				deviceOptions: [],
				VendorsOptions:[],

			}
		},

		mounted() {
			Promise.all([
				this.initCommunity(),
				this.initDevice(),
				this.initVendors()
			]).then(() => {
				this.initData();
			});
		},

		methods: {
			moment,
			onChange(date, dateString) {
				// console.log(date, dateString);
			},
			// 社区数据
			initCommunity() {
				return CommunityService.listPage().then(res => {
					this.communityOptions = res;
				}).catch(err => {});
			},
			initDevice() {
				return DeviceType.listPage().then(res => {
					this.deviceOptions = res;
				}).catch(err => {});
			},
			initVendors(){
				return Vendors.listPage().then(res=>{
					this.VendorsOptions = res;
				}).catch(err => {});
			},
			// 当前页面数据
			initData() {
				this.table.loading = true;
				Equipment.listPage(
					this.table.community_id,
					this.table.device_type_id,
					this.table.name,
					this.table.brand,
					this.table.position,
					this.table.device_sn,
					this.table.device_model,
					this.table.purchase_date,
					this.table.purchase_price,
					this.table.enable_date,
					this.table.depreciation_rate,
					this.table.year_limit,
					this.table.make_mill_id,
					this.table.repair_mill_id,

				).then(res => {
					this.table.data = res.data.map(val => {

						return val;
					});
					this.table.page.total = res.total;
				}).catch(err => {}).finally(() => {
					this.table.loading = false;
				});
			},
			// 提交按钮
			submit() {
				this.table.purchase_date = this.moment(this.table.purchase_date).format('YYYY-MM-DD')
				this.table.enable_date = this.moment(this.table.enable_date).format('YYYY-MM-DD')
				// console.log('时间', this.table.enable_date)
				if (this.id) {
					Equipment.edit(
						this.id,
						this.table.community_id,
						this.table.device_type_id,
						this.table.name,
						this.table.brand,
						this.table.position,
						this.table.device_sn,
						this.table.device_model,
						this.table.purchase_date,
						this.table.purchase_price,
						this.table.enable_date,
						this.table.depreciation_rate,
						this.table.year_limit,
						this.table.make_mill_id,
						this.table.repair_mill_id,

					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {})

				} else {
					Equipment.add(
						this.table.community_id,
						this.table.device_type_id,
						this.table.name,
						this.table.brand,
						this.table.position,
						this.table.device_sn,
						this.table.device_model,
						this.table.purchase_date,
						this.table.purchase_price,
						this.table.enable_date,
						this.table.depreciation_rate,
						this.table.year_limit,
						this.table.make_mill_id,
						this.table.repair_mill_id,
					).then((res) => {
						this.$afterFormSubmit('编辑成功', () => {
							this.cancel();
						});
					}).catch((err) => {})

				}
			},
			cancel() {
				this.$router.push({
					name: 'EquipmentLedger'
				})
			}
		},
	}
</script>

<style lang="less" scoped>


</style>
